var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryMovies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1305_8080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0004 22.6137V43.2536C45.0004 45.038 43.5594 46.4745 41.7839 46.4745H8.54462C6.76268 46.4745 5.32812 45.038 5.32812 43.2536V22.6137C5.32812 20.8357 6.76268 19.3927 8.54462 19.3927H41.7839C42.4851 19.3927 43.1348 19.6182 43.6623 20.0111C44.4729 20.5845 45.0004 21.5379 45.0004 22.6137Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3273 4.19625L44.1829 7.39144C44.363 8.0614 44.0864 8.75069 43.546 9.13076C43.398 9.23383 43.2308 9.31757 43.0442 9.36267L7.82999 18.813C6.9744 19.0449 6.09308 18.536 5.8615 17.6727L5.00592 14.4776C4.90942 14.1232 4.94158 13.7625 5.07667 13.4468C5.25679 12.9959 5.64278 12.6416 6.14455 12.5063L41.3588 3.05603C42.2144 2.82412 43.0957 3.33303 43.3273 4.19625Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 14.9156L18.1222 16.0558L13.4519 11.0376C13.2846 10.8572 13.3682 10.5673 13.6063 10.5093L17.1508 9.55594C17.2666 9.52373 17.3888 9.55594 17.4725 9.64613L22.3744 14.9156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8775 17.196L9.62528 18.3363L5.07715 13.4469C5.25727 12.9959 5.64325 12.6416 6.14503 12.5063L8.65389 11.8299C8.76325 11.7977 8.88547 11.8299 8.9691 11.9201L13.8711 17.196H13.8775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8734 12.6352L26.6212 13.7754L21.9509 8.75713C21.7836 8.57675 21.8672 8.28687 22.1053 8.22889L25.6499 7.27549C25.7656 7.24328 25.8879 7.27549 25.9715 7.36567L30.8734 12.6352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3705 10.3547L35.1183 11.4949L30.448 6.47667C30.2807 6.2963 30.3643 6.00641 30.6023 5.94843L34.1469 4.99503C34.2627 4.96282 34.3849 4.99503 34.4686 5.08522L39.3705 10.3547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3273 4.19625L44.1829 7.39144C44.363 8.0614 44.0864 8.75069 43.546 9.13076L38.9528 4.18981C38.7856 4.01588 38.8692 3.72599 39.1072 3.66157L41.3588 3.05603C42.2144 2.82412 43.0957 3.33303 43.3273 4.19625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9893 19.3927H17.5891L14.3791 25.4481C14.2633 25.6607 14.4177 25.9184 14.6621 25.9184H18.3354C18.4512 25.9184 18.5605 25.854 18.6184 25.7445L21.9893 19.3863V19.3927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7891 19.3927H26.3889L23.1789 25.4481C23.0631 25.6607 23.2175 25.9184 23.4619 25.9184H27.1352C27.2509 25.9184 27.3603 25.854 27.4182 25.7445L30.7891 19.3863V19.3927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1885 19.3927H8.78834L5.57828 25.4481C5.46248 25.6607 5.61688 25.9184 5.86133 25.9184H9.53457C9.65036 25.9184 9.75972 25.854 9.81762 25.7445L13.1885 19.3863V19.3927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5889 19.3927H35.1887L31.9787 25.4481C31.8629 25.6607 32.0173 25.9184 32.2617 25.9184H35.935C36.0508 25.9184 36.1601 25.854 36.218 25.7445L39.5889 19.3863V19.3927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9995 22.6137V25.7767L44.9223 25.9249H41.0625C40.8181 25.9249 40.6637 25.6672 40.773 25.4481L43.6615 20.0112C44.472 20.5845 44.9995 21.5379 44.9995 22.6137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1141 12.9122H6.91045C6.43082 12.9122 6.04199 13.3015 6.04199 13.7818V23.6766C6.04199 24.1569 6.43082 24.5463 6.91045 24.5463H10.1141C10.5937 24.5463 10.9825 24.1569 10.9825 23.6766V13.7818C10.9825 13.3015 10.5937 12.9122 10.1141 12.9122Z",
    fill: "#FF9C07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5118 16.3263C9.10512 16.3263 9.58612 15.8447 9.58612 15.2505C9.58612 14.6564 9.10512 14.1747 8.5118 14.1747C7.91847 14.1747 7.4375 14.6564 7.4375 15.2505C7.4375 15.8447 7.91847 16.3263 8.5118 16.3263Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5118 22.8005C9.10512 22.8005 9.58612 22.3189 9.58612 21.7247C9.58612 21.1306 9.10512 20.6489 8.5118 20.6489C7.91847 20.6489 7.4375 21.1306 7.4375 21.7247C7.4375 22.3189 7.91847 22.8005 8.5118 22.8005Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6115 35.1046L23.8346 31.7612C23.2556 31.4263 22.5352 31.845 22.5352 32.5085V39.1888C22.5352 39.8523 23.2556 40.271 23.8346 39.936L29.6115 36.5927C30.1904 36.2577 30.1904 35.4267 29.6115 35.0917V35.1046Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1305_8080",
    x: 2.9502,
    y: 1,
    width: 44.0498,
    height: 47.4745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1305_8080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1305_8080",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryMovies);
export default __webpack_public_path__ + "static/media/category_movies.52962dbbb76af43ec9ef2c77ce386037.svg";
export { ForwardRef as ReactComponent };